var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm7":"","md5":"","lg4":""}},[_c('login-card',{attrs:{"logo":require('@/assets/tripko_logo.png'),"loading":_vm.loading},on:{"login":_vm.login}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }